export interface ApiClient {
  id: string;
  clientId: string;
  secretKey: string | null;
  accountId: string;
  name: string;
  permissions: string;
  scopes: ApiClientScope[];
  revoked: boolean;
  revokedAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateApiClientRequest {
  accountId: string | null;
  name: string;
  permissions: string;
  scopes: ApiClientScope[];
}

export interface UpdateApiClientRequest {
  name: string;
  permissions: string;
  scopes: ApiClientScope[];
}

export enum ApiClientScope {
  Attributes = "Attributes",
  Photo = "Photo",
  Score = "Score",
  GeoJson = "GeoJson",
  ScoreImpact = "ScoreImpact",
  SafetyTreatmentModel = "SafetyTreatmentModel",
}

export enum ResourceType {
  Any = "*",
  OsaWay = "OsaWay",
  Project = "Project",
}
